import type { HelpdeskRequestBucket } from "@repo/shared-types/helpdesk";
import { RequestError } from "../../shared/web/client.ts";
import { CONVERSATION_UNAVAILABLE_MESSAGE, isConversationUnavailable } from "../../shared/web/linear-conversation/LinearConversation.tsx";

export const EXTERNAL_TRACKING_REFRESH_MS = 30_000;
export const externalRequestsSearch = (search: Record<string, unknown>): { bucket?: HelpdeskRequestBucket } => ({ bucket: search.bucket === "done" ? "done" : undefined });
export function trackingAccessDenied(error: unknown): boolean {
  return error instanceof RequestError && [401, 403, 404].includes(error.status);
}
export function trackingErrorMessage(error: unknown): string {
  if (error instanceof RequestError && error.status === 401) return "Your session has expired. Sign in again to continue.";
  if (trackingAccessDenied(error)) return "This request is unavailable.";
  return "Request details could not be loaded. Try again.";
}
export function externalReplyError(error: unknown): string {
  if (trackingAccessDenied(error)) return trackingErrorMessage(error);
  if (error instanceof RequestError && error.status === 413) return "Attachments must be under 10 MiB each and the complete reply under 50 MiB.";
  if (error instanceof RequestError && error.status === 422) return "This reply contains text reserved for private Helpdesk updates. Edit it and try again.";
  if (isConversationUnavailable(error)) return CONVERSATION_UNAVAILABLE_MESSAGE;
  if (error instanceof RequestError && error.status === 409) return "Replies are no longer available for this ticket. Refresh the request to see its latest status.";
  return "Your reply could not be sent. It is still here; try again.";
}
